// extracted by mini-css-extract-plugin
export var blogPostAuthor = "blog-post-author-module--blogPostAuthor--7eb34";
export var blogPostAuthor__avatar = "blog-post-author-module--blogPostAuthor__avatar--97600";
export var blogPostAuthor__categories = "blog-post-author-module--blogPostAuthor__categories--4343a";
export var blogPostAuthor__rt = "blog-post-author-module--blogPostAuthor__rt--7ea54";
export var cdAuthorImage = "blog-post-author-module--cd-author-image--abf6e";
export var cdBlogAuthorWrapper = "blog-post-author-module--cd-blog-author-wrapper--af4a3";